const urls = {
  images: "/intro/images",
  index: "/intro",
  success: "/intro/success",
  user: "/intro/user",
};

export default urls;
